import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5089a44e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sign-default is-flex is-flex-direction-column scrollbar-wrapper" }
const _hoisted_2 = { class: "has-text-centered is-flex is-align-items-center is-flex-direction-column p-4 pb-0" }
const _hoisted_3 = { class: "profile-wrapper mt-6 p-4" }
const _hoisted_4 = {
  class: "mx-auto mt-2",
  "data-testid": "profile-name"
}
const _hoisted_5 = { class: "message-wrapper is-flex is-flex-direction-column p-4" }
const _hoisted_6 = { class: "is-flex is-justify-content-space-between" }
const _hoisted_7 = { class: "tag" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("lukso-icon", {
  class: "mr-2",
  name: "mail",
  color: "neutral-20",
  size: "small"
}, null, -1 /* HOISTED */))
const _hoisted_9 = { class: "sign-message is-family-monospace pt-4" }

import { onMounted, onUnmounted, ref } from 'vue'

import { useAppStore } from '@/popup/store/AppStore'
import IconButton from '@/popup/components/shared/IconButton.vue'
import Button from '@/popup/components/shared/Button.vue'
import ProfilePicture from '@/popup/components/shared/ProfilePicture/ProfilePicture.vue'
import UserName from '@/popup/components/shared/Miscellaneous/UserName.vue'
import { truncateMiddle, removeSchemaFromUrl } from '@/shared/utils'
import Sanitize from '@/popup/components/shared/Sanitize.vue'
import Notification from '@/popup/components/shared/Notification.vue'
import TransactionData from '@/popup/components/TransactionIFrame/helpers/TransactionData.vue'
import ApprovalHeader from '@/popup/components/shared/ApprovalHeader.vue'
import TransactionInfo from '@/popup/components/Transaction/TransactionInfo.vue'
import { Approval, ApprovalApi, APPROVAL_ACTION } from '@/shared/apis/approvals'
import { Sign } from '@/shared/models/Sign'
import { Transaction } from '@/shared/models/Transaction'
import { useFixedHeader } from '@/popup/compositions/useFixedHeader'

type Props = {
  approval: Approval<keyof ApprovalApi, Sign>
  origin: string
  message: string
  icon: string
}

type Emits = {
  (
    event: 'on-approval-close',
    action: APPROVAL_ACTION,
    validationFn?: () => void
  ): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TransactionSign',
  props: {
    approval: {},
    origin: {},
    message: {},
    icon: {}
  },
  emits: ["on-approval-close"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit
const contentRef = ref<InstanceType<typeof HTMLElement>>()
const scrollOffset = ref<number>(100)
const timerRef = ref()
const { onContentScroll, scrollPercentage } = useFixedHeader(
  scrollOffset,
  contentRef
)

const onClose = async (action: APPROVAL_ACTION, validationFn?: () => void) => {
  emits('on-approval-close', action, validationFn)
}

const props = __props
const transaction = JSON.parse(props.message) as Transaction
const appStore = useAppStore()
const currentProfile = appStore.currentProfile

onMounted(() => {
  timerRef.value = setTimeout(() => {
    onContentScroll()
  }, 100)
})

onUnmounted(() => {
  if (timerRef.value) {
    clearInterval(timerRef.value)
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", {
      ref_key: "contentRef",
      ref: contentRef,
      class: _normalizeClass(`confirmation-window ${true ? 'loaded' : ''}`),
      onScroll: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(onContentScroll) && _unref(onContentScroll)(...args)))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(ApprovalHeader, { icon: _ctx.icon }, {
          subtitle: _withCtx(() => [
            _createVNode(Sanitize, {
              html: _unref(truncateMiddle)(_unref(removeSchemaFromUrl)(_ctx.origin), 10)
            }, null, 8 /* PROPS */, ["html"])
          ]),
          title: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('sign.subtitle')), 1 /* TEXT */)
          ]),
          actions: _withCtx(() => [
            _createVNode(IconButton, {
              tooltip: _ctx.$t('sign.cancel'),
              onOnClick: _cache[0] || (_cache[0] = ($event: any) => (onClose('REJECTED')))
            }, null, 8 /* PROPS */, ["tooltip"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["icon"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(ProfilePicture, {
              "frontend-profile": _unref(currentProfile),
              size: "medium"
            }, null, 8 /* PROPS */, ["frontend-profile"]),
            _createElementVNode("p", _hoisted_4, [
              _createVNode(UserName, {
                profile: _unref(currentProfile),
                "max-width": 210,
                "has-at-sign": true,
                "has-slice-address": true
              }, null, 8 /* PROPS */, ["profile"])
            ])
          ]),
          _createVNode(Notification, {
            type: "warning",
            class: "mt-4"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('sign.transaction')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, [
                _hoisted_8,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('sign.transaction_tag')), 1 /* TEXT */)
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(TransactionInfo, {
                transaction: { ..._unref(transaction), status: 'PENDING' },
                "is-estimate": false
              }, null, 8 /* PROPS */, ["transaction"]),
              _createVNode(TransactionData, {
                class: "wrapped m-0 mt-4",
                data: _unref(transaction).data
              }, null, 8 /* PROPS */, ["data"])
            ])
          ])
        ])
      ])
    ], 544 /* NEED_HYDRATION, NEED_PATCH */),
    _createElementVNode("div", {
      class: _normalizeClass(["buttons p-4", _unref(scrollPercentage) < 85 ? 'shadow' : ''])
    }, [
      _createVNode(Button, {
        variant: "text",
        "is-full-width": true,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (onClose('REJECTED')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('sign.cancel')), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(Button, {
        variant: "primary",
        "is-full-width": true,
        onClick: _cache[3] || (_cache[3] = ($event: any) => (onClose('CONFIRMED')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('sign.confirm')), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      })
    ], 2 /* CLASS */)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})